// import node module libraries
import React, { Fragment, useEffect, useState } from 'react';
import { Card, Col, Form, Image, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { ChevronLeft, ChevronRight } from 'react-feather';
import ReactPaginate from 'react-paginate';
import { FormSelect } from 'components/elements/form-select/FormSelect';

// import utility file
import { Avatar } from '../../../elements/bootstrap/Avatar';
import PersonnelService from '../../services/PersonnelService';

// import utility file

const PersonnelsGridCard = () => {
	const [originalPersonnels, setOriginalPersonnels] = useState([]);
	const [personnels, setPersonnels] = useState([]);

	// Functions for display formatting
	const formatValue = (value, columnId) => {
		if (typeof value === 'string') {
			if (columnId === 'nom' && value) {
				return value.toUpperCase();
			} else if (columnId === 'poste' || columnId === 'adresse') {
				return (
					value && value.charAt(0).toUpperCase() + value.slice(1).toLowerCase()
				);
			} else {
				return value;
			}
		}
		return value;
	};

	const POSTE_CHOICES = [
		{ value: 'enseignant', label: 'Enseignant(e)' },
		{ value: 'enseignant_principal', label: 'Enseignant Principal' },
		{ value: 'surveillant_general', label: 'Surveillant Général' },
		{ value: 'conseiller_pedagogique', label: 'Conseiller Pédagogique' },
		{ value: 'infirmier', label: 'Infirmier' },
		{ value: 'bibliothecaire', label: 'Bibliothécaire' },
		{ value: 'technicien_informatique', label: 'Technicien Informatique' },
		{ value: 'agent_de_service', label: 'Agent de Service' },
		{ value: 'gardien', label: 'Gardien' },
		{ value: 'chauffeur', label: 'Chauffeur' },
		{ value: 'cantine', label: 'Responsable de la Cantine' },
		{ value: 'psychologue_scolaire', label: 'Psychologue Scolaire' },
		{ value: 'educateur_specialise', label: 'Éducateur Spécialisé' },
		{ value: 'assistant_pedagogique', label: 'Assistant Pédagogique' },
		{ value: 'assistant_administratif', label: 'Assistant Administratif' },
		{ value: 'autre', label: 'Autre' }
	];

	const getInitials = (personnel) => {
		const firstName = personnel.prenom
			? personnel.prenom.charAt(0).toUpperCase()
			: '';
		const lastName = personnel.nom ? personnel.nom.charAt(0).toUpperCase() : '';
		return `${lastName} ${firstName}`;
	};

	const formatPoste = (value) => {
		return value.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
	};

	useEffect(() => {
		Promise.all([PersonnelService.getAllActivePersonnels()]).then(
			([personnelsData]) => {
				setOriginalPersonnels(personnelsData);
				setPersonnels(personnelsData);
			}
		);
	}, []);

	// searching code started
	const [searchTerm, setSearchTerm] = useState('');

	const getSearchTerm = (event) => {
		let searchTerm = event.target.value;
		setSearchTerm(searchTerm);
		if (searchTerm !== '') {
			const newPersonnelsList = originalPersonnels.filter((personnel) => {
				let personnelData =
					`${personnel.nom} ${personnel.prenom} ${personnel.adresse} ${personnel.telephone} ${personnel.poste}`.toLowerCase();
				return personnelData.includes(searchTerm.toLowerCase());
			});
			setPersonnels(newPersonnelsList);
			setPageNumber(0);
		} else {
			setPersonnels(originalPersonnels);
		}
	};

	const getFilterTerm = (event) => {
		let filterTerm = event.target.value;

		// Créez un tableau des valeurs possibles pour le poste
		const posteChoicesValues = POSTE_CHOICES.map((choice) => choice.value);

		// Condition pour filtrer les autres postes non listés dans POSTE_CHOICES
		if (filterTerm === 'autre') {
			const newPersonnelsList = originalPersonnels.filter((personnel) => {
				// Ne renvoie que les postes qui ne sont pas dans le tableau posteChoicesValues
				return !posteChoicesValues.includes(personnel.poste);
			});
			setPersonnels(newPersonnelsList);
		}
		// Condition pour filtrer en fonction du poste choisi
		else if (filterTerm !== '') {
			const newPersonnelsList = originalPersonnels.filter((personnel) => {
				return personnel.poste === filterTerm;
			});
			setPersonnels(newPersonnelsList);
		}
		// Si aucun filtre n'est sélectionné, réinitialisez la liste
		else {
			setPersonnels(originalPersonnels);
		}
	};

	const personnelsEleve = personnels.map((personnel) => ({
		...personnel
	}));

	// paging start
	const [pageNumber, setPageNumber] = useState(0);
	const personnelsPerPage = 8;
	const pagesVisited = pageNumber * personnelsPerPage;
	const pageCount = Math.ceil(personnelsEleve.length / personnelsPerPage);
	const changePage = ({ selected }) => {
		setPageNumber(selected);
	};

	const displayPersonnels = personnelsEleve
		.slice(pagesVisited, pagesVisited + personnelsPerPage)
		.map((personnel) => {
			const initials = getInitials(personnel);
			return (
				<Col xl={3} lg={6} md={6} sm={12} key={personnel.id}>
					<Card className="mb-5">
						<Card.Body>
							<div className="text-center">
								<div className="position-relative mb-2">
									<Link to={`/administration/personnel/${personnel.id}`}>
										{personnel.photo ? (
											<Image
												src={personnel.photo}
												alt=""
												className="rounded-circle avatar-xl"
											/>
										) : (
											<Avatar
												type="initial"
												size="xl"
												name={initials}
												className="rounded-circle"
												alt={initials}
											/>
										)}
									</Link>
								</div>
								<Link to={`/administration/personnel/${personnel.id}`}>
									<h4 className="mb-0">{formatValue(personnel.nom, 'nom')}</h4>
								</Link>
								<p className="mb-0 text-uppercase">
									{formatValue(personnel.matricule, 'matricule')}
								</p>
							</div>
							<div className="d-flex justify-content-between border-bottom py-2 mt-6">
								<span>Adresse</span>
								<span className="text-dark">
									{formatValue(personnel.adresse, 'adresse')}
								</span>
							</div>
							<div className="d-flex justify-content-between border-bottom py-2">
								<span>Email</span>
								<span>{formatValue(personnel.email, 'email')}</span>
							</div>
							<div className="d-flex justify-content-between pt-2">
								<span>Poste</span>
								<span className="text-dark">
									{formatPoste(personnel.poste)}
								</span>
							</div>
						</Card.Body>
					</Card>
				</Col>
			);
		});
	// end of paging

	return (
		<Fragment>
			<div className="mb-4">
				<Row className="justify-content-md-between mb-4 mb-xl-0 ">
					<Col xl={2} lg={4} md={6} xs={12}>
						{/* search records */}
						<div className="mb-2 mb-lg-4">
							<Form.Control
								type="search"
								placeholder="Rechercher un personnel"
								value={searchTerm}
								onChange={getSearchTerm}
							/>
						</div>
					</Col>
					<Col xl={2} lg={4} md={6} xs={12}>
						{/* search records */}
						<div className="mb-2 mb-lg-4">
							<Form.Control
								as={FormSelect}
								placeholder="Filtrer par poste"
								options={POSTE_CHOICES}
								onChange={getFilterTerm}
							/>
						</div>
					</Col>
				</Row>
			</div>
			<Row>
				{displayPersonnels.length > 0 ? (
					displayPersonnels
				) : (
					<Col>Aucun personnel correspondant n'a été trouvé.</Col>
				)}
			</Row>
			<ReactPaginate
				previousLabel={<ChevronLeft size="14px" />}
				nextLabel={<ChevronRight size="14px" />}
				pageCount={pageCount}
				onPageChange={changePage}
				containerClassName={'justify-content-center mb-0 pagination'}
				previousLinkClassName={'page-link mx-1 rounded'}
				nextLinkClassName={'page-link mx-1 rounded'}
				pageClassName={'page-item'}
				pageLinkClassName={'page-link mx-1 rounded'}
				disabledClassName={'paginationDisabled'}
				activeClassName={'active'}
			/>
		</Fragment>
	);
};

export default PersonnelsGridCard;
